import { render, staticRenderFns } from "./VesselMonitoringBayHold.vue?vue&type=template&id=49e8d126&scoped=true"
import script from "./VesselMonitoringBayHold.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringBayHold.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringBayHold.vue?vue&type=style&index=0&id=49e8d126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8d126",
  null
  
)

export default component.exports